import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars

import {Page} from '../common/components';


export function ClickableUsageUrl({url}: {url: string}) {
    return <p class="usage url"><a href={ url } target="_blank" rel="noopener noreferrer">{ url }</a></p>;
}

export function UsageUrl({url}: {url: string}) {
    return <p class="usage url">{ url }</p>;
}

export class APIDocPage extends Page {
    pageInit() {
        this.keywords = 'Tenor Free GIF Search API';
        this.description = 'Tenor GIF API seamlessly integrates all of the best features of Tenor\'s GIF library into your app. Tenor GIF API is powerful and free.';
    }
}
